import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { hideLoader, showLoader } from "../../../../../store/actions";

import { useNewSubscriberContext } from "../../Context/NewSubsciberContext";
import { setAAADetails } from "../../Context/NewSubscriberAction";
import { _getOptions } from "../util/getOptions";
import NavigationButtons from "./NavigationButtons";

const AadhaarContainer = () => {
  const {
    ackNumber: AckNumber,
    aadhaarDetails,
    statesList,
    countriesList,
    dispatch: dispatchContext,
  } = useNewSubscriberContext();

  const history = useHistory();
  const dispatch = useDispatch();

  const aadhaarPhoto =
    aadhaarDetails.Certificate.CertificateData[0].KycRes[0].UidData[0].Pht[0];
  const aadhaarPhotoBase64 = `data:image/jpeg;base64,${aadhaarPhoto}`;
  const aadhaar_Address =
    aadhaarDetails.Certificate.CertificateData[0].KycRes[0].UidData[0].Poa[0];
  const aadhaar_Basic =
    aadhaarDetails.Certificate.CertificateData[0].KycRes[0].UidData[0].Poi[0];
  const aadhaarName = aadhaar_Basic.$.name;
  const aadhaarGender = aadhaar_Basic.$.gender;
  const aadhaarNumber =
    aadhaarDetails.Certificate.CertificateData[0].KycRes[0].UidData[0].$.uid;

  const aadhaarDob = aadhaar_Basic.$.dob;
  const aadhaarFatherName = aadhaar_Address.$.co;
  const aadhaarCountry = aadhaar_Address.$.country;
  const aadhaarState = aadhaar_Address.$.state;
  const aadhaarDistrict = aadhaar_Address.$.dist;
  const aadhaarPincode = aadhaar_Address.$.pc;
  const aadhaarAddress1 = aadhaar_Address.$.house;
  const aadhaarAddress2 = aadhaar_Address.$.vtc;
  const aadhaarAddress3 = `${aadhaar_Address.$.dist},${aadhaar_Address.$.state},${aadhaar_Address.$.pc}`;

  // const getKYC = async () =>
  //   dispatchContext(
  //     setKycDetails(await dispatch(getKycDetails({ AckNumber })))
  //   );
  // useEffect(() => {
  //   try {
  //     dispatch(showLoader());
  //     getKYC();
  //   } catch (error) {
  //     console.error(error);
  //     alert(error);
  //   } finally {
  //     dispatch(hideLoader());
  //   }

  //   dispatch(hideLoader());
  // }, [dispatch, AckNumber]);

  // useEffect(() => {
  //   const fetchKycOptions = async () => {
  //     try {
  //       dispatch(showLoader());
  //       const ResCountriesState = await dispatch(getCountriesAndState());
  //       console.log({ ResCountriesState });
  //       if (+ResCountriesState.statusCode === 10000) {
  //         dispatchContext(setCountriesListStateListDetails(ResCountriesState));
  //       }
  //     } catch (error) {
  //       alert(error);
  //       console.error(error);
  //     } finally {
  //       dispatch(hideLoader());
  //     }
  //   };
  //   fetchKycOptions();
  // }, []);
  // const { kycDetails } = useNewSubscriberContext();

  const submit = async () => {
    try {
      dispatch(showLoader());

      const params = {
        AckNumber,
        District: aadhaarDistrict,
        PinCode: aadhaarPincode,
        StateName: statesList.find(
          (item) =>
            item.label.toLowerCase().trim() ===
            aadhaarState.toLowerCase().trim()
        ).value,
        Address1: aadhaarAddress1,
        Addreess2: aadhaarAddress2,
        CountryName: countriesList.find(
          (item) =>
            item.label.toLowerCase().trim() ===
            aadhaarCountry.toLowerCase().trim()
        ).value,
        IdentifierNum: aadhaarNumber,
        IdentifierType: 150,
        SubscriberName: aadhaarName,
        Gender: aadhaarGender,
        aadhaar_number: aadhaarNumber,
        DOB: aadhaarDob.replaceAll("-", "/"),
      };
      // const response = await dispatch(saveKycDetails(params));
      // if (+response.statusCode === 10000) {
      // await getKYC();

      dispatchContext(setAAADetails(params));
      history.push({
        pathname: "/nps/AddSubs/personal-details",
      });
      // }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  return (
    <div className="p-3 w-50">
      <div style={{ fontSize: "14px", color: "#002856" }}>e-Aadhaar</div>
      <div
        style={{
          border: "1px solid",
          width: "540",
          padding: "12px",
        }}
        className="d-flex flex-row"
      >
        <div style={{ width: "180px" }}>
          <img
            style={{ width: "160px" }}
            src={aadhaarPhotoBase64}
            alt="Aadhaar Photograph"
          />
        </div>
        <div>
          <p style={{ marginBottom: "2px" }}>{aadhaarName}</p>
          <p style={{ marginBottom: "2px" }}>DOB: {aadhaarDob}</p>
          <p>Gender: {aadhaarGender}</p>
          <p style={{ fontWeight: "Bold" }}>Address: </p>
          <p style={{ marginBottom: "2px" }}>{aadhaarFatherName},</p>
          <p style={{ marginBottom: "2px" }}>{aadhaarAddress1},</p>
          <p style={{ marginBottom: "2px" }}>{aadhaarAddress2},</p>
          <p>{aadhaarAddress3}</p>
        </div>
      </div>
      <NavigationButtons
        submit={submit}
        goBack={() =>
          history.push({
            pathname: "/nps/AddSubs/new-reg",
          })
        }
      />
    </div>
  );
};

export default AadhaarContainer;
